/* istanbul ignore file */
import FormButtonsLayout from '../../../layout/form/FormButtons/FormButtonsLayout';
import { Box } from '@mui/material';

const timelineItemFormBodySx = {
  minHeight: 0,
  padding: '11px 16px 12px',
  whiteSpace: 'pre-line',
} as const;

export interface BaseTimelineItemFormLayoutProps {
  onSubmitAction?: () => void;
  children?: React.ReactNode;
  onCancel?: () => void;
}

interface TimelineItemFormLayoutProps extends BaseTimelineItemFormLayoutProps {
  isCreateForm?: boolean;
}

const BaseTimelineItemFormLayout = ({
  children,
  isCreateForm = false,
  onSubmitAction,
  onCancel,
}: TimelineItemFormLayoutProps) => {
  return (
    <Box className={`card ${isCreateForm ? 'border-success' : ''}`}>
      <Box className="card-body" sx={timelineItemFormBodySx}>
        {children}
        <FormButtonsLayout onCancelAction={onCancel} onSubmitAction={onSubmitAction} />
      </Box>
    </Box>
  );
};

export default BaseTimelineItemFormLayout;
